import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { numberOrZero } from '@ps/utils';

import {
  SurveyEpcActualDto,
  SurveyEpcEstimateDto,
  SurveyEpcEstimateRequestDto,
  SurveyEpcPlatformDto,
} from './dtos/survey-epc.dto';

@Injectable({ providedIn: 'root' })
export class SurveyEpcApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = `${this._env.pureSpectrum.url}/survey-statistcs`;

  public estimate(payload: SurveyEpcEstimateRequestDto): Observable<number> {
    return this._http
      .post<SurveyEpcEstimateDto>(`${this._baseUrl}/epc-estimate`, payload)
      .pipe(map((dto) => numberOrZero(dto.epcEstimate)));
  }

  public platform(countryCode: string): Observable<number> {
    return this._http
      .get<SurveyEpcPlatformDto>(`${this._baseUrl}/epc-platform/${countryCode}`)
      .pipe(map((dto) => numberOrZero(dto.epcPlatform)));
  }

  public actual(surveyId: number): Observable<number> {
    return this._http
      .get<SurveyEpcActualDto>(`${this._baseUrl}/epc-actual/${surveyId}`)
      .pipe(map((dto) => numberOrZero(dto.epcActual)));
  }
}
